const classesCollection = {
  sticky: 'is-sticky',
  open: 'is-open',
  active: 'is-active',
  mobileOpen: 'filter-open',
  disalbedToggle: 'disabled-toggle'
};

register('collection', {
  async onLoad() {
    this.equalProductsTitle();
  	this.filterToggle();
  	this.facetsAction();
  	this.slideoutFilter();
    this.initReadmore();
    this.popularSlider();
    // this was listed as a conflict, not sure
    const winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (this.container.querySelector('.collection-hero .js-auto-height') && winWidth >= 768) {
      new ResponsiveAutoHeight(this.container.querySelectorAll('.collection-hero .js-auto-height'));
    }
    const nostoSlider = document.querySelectorAll('.recommendations-slider');
    this.initCollectionSlider(nostoSlider);
  },

  onUnload() {
  },

  filterToggle() {
  	const accordions = document.querySelectorAll('.plp-facet-container');
	  accordions.forEach(accordion => {
	    // get all `panel` elements
	    const panel = accordion.querySelector('.plp-facet__options');
      // get `title` element
      const title = accordion.querySelector('.plp-facet__title');

      // toggle 'active' modifier on title click
      title.addEventListener('click', (e) => {
        if ( title.classList.contains(classesCollection.disalbedToggle)) {
          e.preventDefault();
          return false;
        }
      	accordion.classList.toggle('is-expanded');
      	accordion.classList.toggle('is-collapsed');
      });
	  });

    const close_slideout_btn = document.querySelector('.js-filter-submit');
    const ro = new ResizeObserver( debounce(function(entries){
      for (let entry of entries) {
        accordions.forEach(accordion => {
          const title = accordion.querySelector('.plp-facet__title[disabled]');
          if ( title && viewportWidth() < 768 ) {
            title.classList.remove(classesCollection.disalbedToggle);
          }else if( title ){
            title.classList.add(classesCollection.disalbedToggle);
            title.parentNode.classList.remove('is-collapsed');
            title.parentNode.classList.add('is-expanded');
          }
        });
        if (close_slideout_btn && viewportWidth() >= 768) {
          close_slideout_btn.click();
        }
      }
    }, 200));
    ro.observe(document.body);
  },
  facetsAction(){
  	const facets_container = document.querySelectorAll('.plp-facets .plp-facet-container');
  	facets_container.forEach( container => {
  		let facets_link = container.querySelectorAll('.plp-facet__link');
  		let facet_reset = container.querySelector('.plp-facet__reset');
	  	facets_link.forEach( link => {
	  		link.addEventListener('click', (e) => {
	  			e.preventDefault();
	  			if ( link.closest('.plp-facet__List--radio') ) {
	  				container.querySelectorAll('.plp-facet__link--active').forEach( active_link => {
	  					active_link.classList.remove('plp-facet__link--active');
	  				})
	  			}
	  			link.classList.toggle('plp-facet__link--active');
	  			if (container.querySelector('.plp-facet__link--active')) {
	  				container.classList.add('is-selected');
	  				container.querySelector('.plp-facet__selected') ? container.querySelector('.plp-facet__selected').innerText = link.innerText : false;
	  			}else{
	  				container.classList.remove('is-selected')
	  			}
          let title_facet_count = container.querySelector('.plp-facet__title span');
          if (!title_facet_count) {
            title_facet_count = document.createElement("span");
            container.querySelector('.plp-facet__title').appendChild(title_facet_count);
          }
          title_facet_count.innerHTML = '(' + container.querySelectorAll('.plp-facet__link--active').length + ')';
          !container.querySelectorAll('.plp-facet__link--active').length ? title_facet_count.style.display = 'none' : title_facet_count.style.display = 'inline-block';
	  		})
	  	});
	  	if( facet_reset ){
	  		facet_reset.addEventListener('click', (e) => {
	  			e.preventDefault();
	  			container.classList.remove('is-selected');
	  			facets_link.forEach( link => {
	  				link.classList.remove('plp-facet__link--active');
	  			})
	  		})
	  	}
  	});
  },
  slideoutFilter(){
  	const slideout_btn = document.querySelector('.js-filter-slideout');
  	const close_slideout_btn = document.querySelector('.js-filter-submit');
  	const backBtn = document.querySelector('.js-mobile-nav-toggle');
  	const body = document.querySelector('body');
  	const mobileNavToggle_btn = document.querySelectorAll('.js-mobile-nav-toggle');
  	const facets_container = document.querySelectorAll('.plp-facets .plp-facet-container');
    const collection_section = document.querySelector('[data-section-type="collection"]');
  	if( !collection_section ) return;

    collection_section.addEventListener('click', (e) => {
      const filter_container = collection_section.querySelector('.plp-filters-container');
      if ( !filter_container ){
        return;
      }
      if (event.target.classList.contains('js-filter-slideout')){
        e.preventDefault();
        filter_container.classList.add(classesCollection.active);
        body.classList.add(classesCollection.mobileOpen);
        backBtn.classList.add(classesCollection.active);
        const announcementBar = document.querySelector('.announcementBar');
        const promotionBar = document.querySelector('.promotionBar');
        const site_header = document.querySelector('.site-header');
        let headerHeight = announcementBar ? announcementBar.offsetHeight : 0;
        headerHeight += (promotionBar ? promotionBar.offsetHeight : 0) + (site_header ? site_header.offsetHeight : 0);
        if (site_header.classList.contains('is-sticky')) {
          headerHeight = (site_header ? site_header.offsetHeight : 0)
        }else{
          let currScrollTop = window.scrollY;
          headerHeight -= currScrollTop;
        }

        filter_container.style.paddingTop = headerHeight + 'px';
        facets_container.forEach( container => {
          container.classList.remove('is-expanded');
          container.classList.add('is-collapsed');
        })
      }else if (event.target.classList.contains('js-filter-submit')){
        e.preventDefault();
        filter_container.classList.remove(classesCollection.active);
        body.classList.remove(classesCollection.mobileOpen);
        backBtn.classList.remove(classesCollection.active);
      }
      return;
    });
  },
  equalProductsTitle(){
    const sameHeights = function(){
      let product_card = document.querySelectorAll('.plp-products .product-card');
      let product_info = document.querySelectorAll('.plp-products .product-card .product-info');
      let product_swatches = document.querySelectorAll('.plp-products .product-card .product-card__swatches');
      let elems = [].slice.call(product_card);
      product_info = [].slice.call(product_info);
      product_swatches = [].slice.call(product_swatches);

      let card_in_row = 2;
      if (viewportWidth() > 1023 ) {
        card_in_row = 3;
      }

      elems.forEach(function(elem, index, arr){
        if (index % card_in_row == 0) {
          let els = product_info.slice(index, index+ card_in_row);
          let tallest = Math.max.apply(Math, els.map(function(elem, index) {
            elem.style.minHeight = ''; // clean first
            return elem.offsetHeight;
          }));
          els.forEach(function(el, i, arr){
            el.style.minHeight = tallest + 'px';
          })
          els = product_swatches.slice(index, index+card_in_row);
          tallest = Math.max.apply(Math, els.map(function(elem, index) {
            elem.style.minHeight = ''; // clean first
            return elem.offsetHeight;
          }));
          els.forEach(function(el, i, arr){
            el.style.minHeight = tallest + 'px';
          })
        }
      });
    }
    const refresh = function(){
      if(resized) {
        requestAnimationFrame(sameHeights);
      }
      clearTimeout(timeout);
      timeout = setTimeout( refresh, 100);
      resized = false;
    };

    var resized = true,
    timeout = null,
    self = this;
    window.addEventListener('resize', function() { resized = true; });
    refresh();
  },
  popularSlider(){
    const popular_image = this.container.querySelectorAll('.plp-shop-popular__item img,.plp-sbc__category img');
    popular_image.forEach( img => {
      img.classList.add('responsive-image__image','lazyload');
      let wrapper = document.createElement('div');
      wrapper.classList.add('responsive-image__wrapper');
      img.parentNode.insertBefore(wrapper, img);
      wrapper.appendChild(img);
    });
    const sliders = this.container.querySelectorAll('[tiny-slider]');
    sliders.forEach(slide => {
      let m_item_to_show = 2;
      let disable = false;
      let control = true;
      let item_to_show = 4;
      if (slide.classList.contains('plp-sbc__listing')) {
        m_item_to_show = 2.7;
        disable = true;
        control = false;
        item_to_show = 2.7;

      }
      var slider = tns({
        container: slide,
        items: m_item_to_show,
        gutter: 20,
        slideBy: 'page',
        center: false,
        autoplay: false,
        controls: false,
        nav: true,
        navPosition: 'bottom',
        mouseDrag: true,
        preventScrollOnTouch: 'auto',
        responsive: {
          768: {
            disable : disable,
            items: item_to_show,
            controls: control
          }
        }
      });
    });
  },
  initReadmore(){
    if( viewportWidth() <= 768  ){
      ReadMore.init(document.querySelectorAll('.collection-desc .js-read-more,.collection-faqs .js-read-more'));
    }else{
      ReadMore.init(document.querySelectorAll('.collection-faqs .js-read-more'));
    }
  },
  initCollectionSlider(sliders) {
    if ( sliders.length > 0 ) {
      sliders.forEach((slider) => {
          var slider = tns({
              container: slider,
              items: 2,
              gutter: 20,
              slideBy: 'page',
              center: false,
              autoplay: false,
              controls: false,
              nav: true,
              navPosition: 'bottom',
              mouseDrag: true,
              preventScrollOnTouch: 'auto',
              responsive: {
                  768: {
                      items: 4,
                  }
              }
          });     
      });
    }
  }
});

load('collection');